<template>
  <div class="app-container">
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>

    <div class="left-right">
      <div class="left">
        <TreeNav
          :treeList="treeList"
          :filterKey="`deptName`"
          :is-arr="true"
          :defaultRxpandAll="true"
          :expandOnClickNode="false"
          :highlightCurrent="searchParams.deptId ? true : false"
          :placeholder="`请输入部门名称`"
          @on-search="handleNavSearch"
          @on-tree="handleNavTree"
          authIdentity="system:account"
        ></TreeNav>
      </div>

      <div class="right">
        <!--   列表     -->
        <TablePublic
          :colLists="colLists"
          :tableData="tableData"
          :paginationFlag="true"
          :total="total"
           :pageParams="queryParams" @pageChange="getList"
        >
          <template slot="statusText" slot-scope="scope">
            <div class="center">
              <span v-if="scope.data.status == 0" class="normal">正常</span>
              <span v-else class="disable">停用</span>
            </div>
          </template>
          <template slot="solts" slot-scope="scope">
            <el-link
              type="primary"
              v-hasPermi="[authIdentity + ':edit']"
              @click="handleEdit(scope.data, '编辑')"
            >编辑</el-link>
            <el-link
              v-if="scope.data.status == 0"
              type="primary"
              v-hasPermi="[authIdentity + ':stop']"
              @click="handleStatus(scope.data, '停用')"
            >停用</el-link>
            <el-link
              v-if="scope.data.status == 1"
              type="primary"
              v-hasPermi="[authIdentity + ':start']"
              @click="handleStatus(scope.data, '启用')"
            >启用</el-link>
            <el-link
              type="primary"
              v-hasPermi="[authIdentity + ':detail']"
              @click="handleView(scope.data, '详情')"
            >详情</el-link>
            <el-link
              type="primary"
              v-hasPermi="[authIdentity + ':resetting']"
              @click="handlePwd(scope.data, '重置')"
            >重置密码</el-link>
            <el-link
              type="danger"
              v-hasPermi="[authIdentity + ':del']"
              @click="handleDel( scope.data, '删除')"
            >删除</el-link>
          </template>
        </TablePublic>
      </div>
    </div>
    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component :ref="currentView" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
/**  引入 -- 组件  */
import { mapState, mapActions } from 'vuex'
import { getUserList, delUsers, modifyUserStatus } from '@/api/system/system'

import TreeNav from '@/views/system/account/components/treeNav'
import TablePublic from '@/components/tablePublic'

import SearchComponent from '@/components/searchComponent'
import myform from '@/views/system/account/components/form'
import pwdForm from '@/views/system/account/components/pwdForm'
import Mdialog from '@/components/Mdialog'

export default {
  name: 'index',
  components: { SearchComponent, TreeNav, TablePublic, myform, pwdForm, Mdialog },
  // components: { MSearch, MAdd, MEdit, MExamine, TreeNav },
  // mixins: [Mixins],
  // watch: {
  //   'tableData.length'(newLength) {
  //     console.log('数组长度已经改变了', newLength)
  //     this.estimateTableHeight(newLength)
  //   },
  // },
  data() {
    return {
      authIdentity: 'system:account',
      type: '',
      dialogWidth: '50%',
      currentView: 'myform',
      dialogVisible: false,
      title: '',
      queryParams: {},
      searchParams: {},
      selectOrInputList: [
        {
          model: 'status',
          placeholder: '状态',
          value: 'value',
          label: 'label',
          list: CONSTANTS.normalStatus,
          type: 'select',
        },
        {
          model: 'userName',
          placeholder: '请输入用户名称',
          class: 'home',
          type: 'input',
        },
      ],
      colLists: [
        {
          prop: 'userName',
          label: '用户名称',
          isTrue: true,
        },
        {
          prop: 'phone',
          label: '联系方式',
          isTrue: true,
        },
        {
          prop: 'depts',
          label: '所属部门',
          isTrue: true,
        },
        {
          prop: 'roles',
          label: '所属角色',
          isTrue: true,
        },
        {
          prop: 'statusText',
          label: '状态',
          isTrue: true,
          width: 140,
          formSolt: true,
        },
        {
          prop: 'createDate',
          label: '创建日期',
          isTrue: true,
        },
        {
          label: '操作',
          prop: 'address',
          solt: true,
          isTrue: true,
          width: 280,
          rightFlag: true,
        },
      ],
      loading: false,
      tableData: [],
      total: 1,
    }
  },
  created() {
    this.getDeptList()
    this.getList()
  },
  computed: {
    ...mapState({ treeList: (state) => state.system.deptTreeList }),
  },
  methods: {
    ...mapActions({ getDeptList: 'system/getDeptList' }),
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getUserList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.createDate = this.parseTime(item.createTime, '{y}-{m}-{d}')
              item.depts = item.deptRespList ? item.deptRespList.map((dept) => dept.deptName).join(',') : '-'
              item.roles = item.roleRespList ? item.roleRespList.map((role) => role.roleName).join(',') : '-'
              item.statusText = CONSTANTS.getStatusConversion(item.status, 'normalStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.cancel()
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel() {
      // if (this.loading) {
      //   return
      // }

      this.$refs[this.currentView].reset()
      this.dialogVisible = false
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1
      }
      this.getList()
    },
    handleNavSearch() {},

    handleNavTree(data) {
      this.queryParams = Object.assign(this.queryParams, { deptId: data.id })
      this.getList()
    },
    handleAdd() {
      this.type = 'save'
      this.title = '新增账号'
      this.dialogWidth = '50%'
      this.dialogVisible = true
      this.currentView = 'myform'
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看用户信息'
      this.dialogWidth = '50%'
      this.dialogVisible = true
      this.currentView = 'myform'

      row.updateBy = row.updateBy || row.createBy
      row.roleNames = row.roleRespList && row.roleRespList.map((role) => role.roleName).join(', ')
      row.deptNames = row.deptRespList && row.deptRespList.map((dept) => dept.deptName).join(', ')
      row.updateTime = this.parseTime(row.updateTime || row.createTime, '{y}-{m}-{d} {h}:{i}')
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handlePwd(row) {
      this.type = 'pwd'
      this.title = '重置密码'
      this.dialogWidth = '30%'
      this.dialogVisible = true
      this.currentView = 'pwdForm'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row, 1)
        }
      })
    },
    handleEdit(row) {
      this.type = 'update'
      this.title = '编辑用户'
      this.dialogWidth = '50%'
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleStatus(row, type) {
      let data = {
        id: row.id,
        status: type == '停用' ? 1 : 0,
      }
      this.$confirm(`确认${type}?`, '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          modifyUserStatus(data).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功`)
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '',
          // })
        })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delUsers(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>

<style lang='less' scoped>
// @import '../../../assets/styles/newIndex';
// @import 'src/assets/styles/heightTable';
// @import 'src/assets/styles/form.scss';
.disable {
  color: red;
}
.normal {
  color: green;
}
/deep/ .delbutton.el-button--text {
  color: red;
}
/deep/ .el-button--text {
  font-size: 14px;
}
.left-right {
  display: flex;
  .left {
    width: 200px;
  }
  .right {
    flex: 1;
    margin-left: 20px;
  }
}
</style>
